import React, { Component } from 'react';
import classNames from 'classnames'
import MyIcons from '../../blocks/MyIcons'
import MyLink from '../../blocks/MyLink'
import MyLinkOut from '../../blocks/MyLinkOut'
import styles from './index.css';
import {NavLink} from 'react-router-dom'

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {LangChangeEventContext} from '../../contexts/LangContext';

// const MENU_ARRAY={
//   'ru':[
//     '/assets/menu/break_ru.pdf',
//     '/assets/menu/main_ru.pdf',
//     '/assets/menu/bar_ru.pdf',
//     '/assets/menu/cocktails_ru.pdf',
//     '/assets/menu/.pdf'],
//   'en':[
//     '/assets/menu/break_en.pdf',
//     '/assets/menu/main_en.pdf',
//     '/assets/menu/bar_en.pdf',
//     '/assets/menu/cocktails_en.pdf',
//     '/assets/menu/.pdf']
// }


export default class Header extends Component {
  state={
    isOpen:false,
    isScrolled:false
  }
  componentWillMount(){
    window.addEventListener('scroll', this.onScroll);
    // isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  }
  componentWillUnmount(){
    window.removeEventListener('scroll', this.onScroll)
  }
  componentDidMount(){
    let linksQ = document.querySelectorAll('.'+styles['itemLink']+'.'+styles['menuActive']);
    let lanksMain = document.querySelectorAll('.'+styles['itemLink']+'.'+styles['mainCheck']);
    // console.log(linksQ);
    // console.log( linksQ.length +' - '+ lanksMain.length);
    if( linksQ.length > lanksMain.length){
      document.querySelector('.'+styles['mainCheck']).classList.remove(styles['menuActive']);
    }
  }

  onScroll =()=>{
    if(document.documentElement.offsetWidth>600) return false

      if( (document.body.scrollTop>2 || document.documentElement.scrollTop>2) && this.state.isScrolled === false){
        console.log('s visible')
        this.setState({isScrolled:true})
      }else
      if( !( !(document.body.scrollTop<3) || !(document.documentElement.scrollTop<3)) && this.state.isScrolled === true){
        console.log('s non')
        this.setState({isScrolled:false})
      }
    
  }
  mobile(){
    if(document.documentElement.clientWidth < 1200) return true;
    return false;
  }
  mobileMiddle(){
    if( (document.documentElement.clientWidth > 1199) && (document.documentElement.clientWidth < 1441)) return true;
    return false;
  }
  toggleMenu = () => {
    this.setState({
      isOpen:!this.state.isOpen
    });
  }
  render() {
    return (
      <LangChangeEventContext.Consumer>
        {({lang,changeRu,changeEn}) =>(
          <div className={classNames(styles['header'], 
                          this.props.steps[1]     && styles['is-step1'], 
                          this.props.steps[2]     && styles['is-step2'],
                          this.props.steps[3]     && styles['is-step3'],
                          this.props.steps[10]    && this.props.steps[4]     && styles['is-step4'],
                          this.state.isOpen       && styles['is-open'],
                          this.state.isScrolled   && styles['is-mobileScroll'],
                          this.mobileMiddle()     && styles['is-middle'],
                          this.mobile()           && styles['is-mobile'])} >
            <div className={styles.langWrapper}>
              <div className={classNames(styles.lang, lang.language==='ru'?styles.isActive:'')} onClick={changeRu}> РУС </div>
              <div className={classNames(styles.lang, lang.language==='en'?styles.isActive:'')} onClick={changeEn}> ENG  </div>
            </div>
            <a href='/' className={classNames(styles['logoWrapper'],this.props.isMain&&styles['is-main'])} >
              <img alt="" src="/assets/logo.jpg" className={styles['logoImg']} />
            </a>
            
            <div className={classNames(styles.mobileButtonWrapper, this.state.isOpen && styles['is-open'])} onClick={this.toggleMenu}>
              <div className={styles.mobileButton}></div>
            </div>
            
            <div className={classNames(styles.headerWrapper)} >
              <MyLink classStyle={styles.logoLink} to="/">
                <img alt="logo" src="/assets/logo.jpg" className={styles.logoImg}/>
              </MyLink>
              <div className={styles.column} >
                <MyLink classStyle={styles.itemLink} to="/">
                  <MyIcons className={styles.icon} icon='header'/>
                  <div className={styles.itemText}>
                    {lang.t('main')}
                  </div>
                </MyLink>
                <div className={classNames(styles.itemLink, styles.itemLinkMenu)}>
                  <MyIcons className={styles.icon} icon='header'/>
                  <div className={styles.itemText}>
                    <ExpansionPanel className={styles['ep']}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={styles['epHeaderWrapper']}>
                        <div className={styles.epHeader}>{lang.t('menu')}</div>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails  className={styles.epDetWrapper}>
                        <div className={styles.epWrapper}>
                          {
                            this.props.menu && this.props.menu.map( (item, idx)=>{
                              let link  = lang.language==='ru'?item.file:item.fileEn;
                              let title = lang.language==='ru'?item.title:item.titleEn;
                              return(
                              <a href={'http://api.dantemoscow.ru/'+link} className={styles.epItem}  target='_blank' key={idx}>{title}</a>
                              )
                            })
                          }
                        
                          {/* <a href={MENU_ARRAY[lang.language][0]} className={styles.epItem} target='_blank'>{lang.t('menuBr')}</a>
                          <a href={MENU_ARRAY[lang.language][1]} className={styles.epItem} target='_blank'>{lang.t('menuMain')}</a>
                          <a href={MENU_ARRAY[lang.language][2]} className={styles.epItem} target='_blank'>{lang.t('menuBar')}</a>
                          <a href={MENU_ARRAY[lang.language][3]} className={styles.epItem} target='_blank'>{lang.t('menuCocCart')}</a> */}
                        </div>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </div>
                </div>
                <MyLink classStyle={styles.itemLink} to="/gallery">
                  <MyIcons className={styles.icon} icon='header'/>
                  <div className={styles.itemText}>
                    {lang.t('gallery')}
                  </div>
                </MyLink>
                <MyLink classStyle={styles.itemLink} to="/contacts">
                  <MyIcons className={styles.icon} icon='header'/>
                  <div className={styles.itemText}>
                    {lang.t('contacts')}
                  </div>
                </MyLink>
              </div>              
              <div className={styles.socWrapper}>
                <MyLinkOut classStyle={styles.socLink} to=" https://www.facebook.com/dante.moscow/">
                  <MyIcons className={styles.iconSoc} icon='fb'/>
                </MyLinkOut>
                <MyLinkOut classStyle={styles.socLink} to="https://www.instagram.com/dante_moscow/">
                  <MyIcons className={styles.iconSoc} icon='ins'/>
                </MyLinkOut>
              </div>
            </div>
            
            <div className={styles.headerWrapperMiddle} >
              <div className={styles.column} >
                <NavLink activeClassName={styles.menuActive} className={classNames(styles.itemLink, styles.mainCheck)} to="/">
                  <div className={styles.itemText}>
                    {lang.t('main')}
                  </div>
                </NavLink>
                <div className={classNames(styles.itemLink, styles.itemLinkMenu)}>
                  <div className={styles.itemText}>
                    <ExpansionPanel className={styles['ep']}>
                      <ExpansionPanelSummary className={styles['epHeaderWrapper']} expandIcon={<ExpandMoreIcon />} >
                        <div className={styles.epHeader}>{lang.t('menu')}</div>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails  className={styles.epDetWrapper}>
                        <div className={styles.epWrapper}>
                          {
                            this.props.menu && this.props.menu.map( (item, idx)=>{
                              let link  = lang.language==='ru'?item.file:item.fileEn;
                              let title = lang.language==='ru'?item.title:item.titleEn;
                              return(
                              <a href={'http://api.dantemoscow.ru/'+link} className={styles.epItem}  target='_blank' key={idx}>{title}</a>
                              )
                            })
                          }
                          {/* <a href={MENU_ARRAY[lang.language][0]} className={styles.epItem} target='_blank'>{lang.t('menuBr')}</a>
                          <a href={MENU_ARRAY[lang.language][1]} className={styles.epItem} target='_blank'>{lang.t('menuMain')}</a>
                          <a href={MENU_ARRAY[lang.language][2]} className={styles.epItem} target='_blank'>{lang.t('menuBar')}</a>
                          <a href={MENU_ARRAY[lang.language][3]} className={styles.epItem} target='_blank'>{lang.t('menuCocCart')}</a> */}
                        </div>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </div>
                </div>
                <NavLink activeClassName={styles.menuActive} className={styles.itemLink} to="/gallery">
                  <div className={styles.itemText}>
                    {lang.t('gallery')}
                  </div>
                </NavLink>
                <NavLink activeClassName={styles.menuActive} className={styles.itemLink} to="/contacts">
                  <div className={styles.itemText}>
                    {lang.t('contacts')}
                  </div>
                </NavLink>
              </div>
              <div className={styles.socWrapper}>
                <MyLinkOut classStyle={styles.socLink} to=" https://www.facebook.com/dante.moscow/">
                  <MyIcons className={styles.iconSoc} icon='fb' width='25px' height='25px'/>
                </MyLinkOut>
                <MyLinkOut classStyle={styles.socLink} to="https://www.instagram.com/dante_moscow/">
                  <MyIcons className={styles.iconSoc} icon='ins' width='25px' height='25px'/>
                </MyLinkOut>
              </div>
            </div>
          </div>
        )}
      </LangChangeEventContext.Consumer>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Header/index.js